import script from "./bumenwangpan.vue?vue&type=script&setup=true&lang=js"
export * from "./bumenwangpan.vue?vue&type=script&setup=true&lang=js"

import "./bumenwangpan.vue?vue&type=style&index=0&id=eae7d9be&lang=less&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-eae7d9be"]])

export default __exports__